/* eslint-disable */
/* @flow */

import React, { Component } from 'react'
import { Image, Text, TouchableOpacity, View, StatusBar, TouchableWithoutFeedback, Keyboard } from 'react-native'


import { Images } from '../Themes'

import styles from './Styles/MainNavBarScreenStyle'
import { Fonts } from '../Themes'
import BackButtonComponent from '../Components/BackButtonComponent'
import { SvgBackButton,SvgClose} from '../Components/SvgComponent';
CustomStatusBar = ({ backgroundColor, ...props }) => (
  <View style={[styles.statusBar, { backgroundColor }]}>
    <StatusBar translucent backgroundColor={backgroundColor} {...props} />
  </View>
);
class MainNavBarScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      leftButtons: [],
      rightButtons: [],
      title: ''
    }
  }

  checkTypeImage = (type) => {

    switch (type) {
      case 'close':
        return Images.crossNav

      case 'profile':
        return Images.profiles

      case 'settings':
        return Images.settings

      case 'hamburger':
        return Images.menuIcon

      case 'grid':
        return Images.grid

      case 'list':
        return Images.list

      case 'home':
        return Images.homeIcon

      default:
        break;
    }

  }
  setLeftNavBarButtons = (buttons) => {
    this.setState({ leftButtons: buttons })
  }

  setRightNavBarButtons = (buttons) => {
    this.setState({ rightButtons: buttons })
  }
  setTitle = (title) => {
    this.setState({ title })
  }
  checkOnline = () => {


  }
  renderButtonLeft = (button, key) => {
    const disableLeft = this.props.disableLeft ? this.props.disableLeft : false
    return (
      <TouchableOpacity
        disabled={!button.onPress || disableLeft}
        key={key}
        onPress={button.onPress}
        style={[styles.button,{ paddingTop:button.type === 'closeBlue' ? 35 : 14}]}>
        {button.type === 'back' && <SvgBackButton />}
        {button.type === 'closeBlue' && <SvgClose size="20" />}
        {button.type !== 'back' && button.type !== 'title' && button.type === 'closeBlue' && <Image style={styles.image} source={this.checkTypeImage(button.type)} />}
        {button.type === 'title' && (
          <Text style={styles.buttonTitle}>{button.title}</Text>
        )}
      </TouchableOpacity>
    )
  }
  renderButtonRight = (button, key) => {

    return (
      <TouchableOpacity
        delayPressIn={0}
        disabled={!button.onPress}
        key={key}
        onPressIn={button.onPress}
        style={styles.button}>
        {button.type === 'back' && <SvgBackButton />}

        {button.type !== 'back' && button.type !== 'title' && <Image style={styles.image} source={this.checkTypeImage(button.type)} />}
        {button.type === 'title' && (
          <Text style={[styles.buttonTitle, this.props.rightTitleStyle]}>{button.title}</Text>
        )}
      </TouchableOpacity>
    )
  }

  renderTitle = () => {
    const { title } = this.props


    if (title) {
      if( typeof title === 'function' ) return title (this, this.props)
      return <Text style={[styles.titleBlack, { alignSelf: 'center' }]}>{title}</Text>
    }

    return <Image source={Images.kargoeLogoHome} resizeMode="contain" style={[styles.logo]} />
  }

  renderContent = () => {

    const { leftButtons, rightButtons } = this.state

    return (

      <View>

        <View style={styles.statusBar} />
        <StatusBar translucent barStyle="dark-content" style={{ backgroundColor: '#FFFFFF' }} />
        <View style={styles.content}>
          <View style={[styles.leftButtons, { zIndex : 2 }]}>
            {leftButtons &&
              leftButtons.map((button, i) => this.renderButtonLeft(button, i))}
          </View>
          {this.props.auxViewLeft && this.props.auxViewLeft}
          {this.renderTitle()}
          {this.props.auxViewRight && this.props.auxViewRight}
          <View style={[styles.rightButtons, { zIndex : 2 }]}>
            {rightButtons &&
              rightButtons.map((button, i) => this.renderButtonRight(button, i))}
          </View>
        </View>
      </View>

    )
  }

  render() {
    return (
      <View
        style={[
          styles.container,
          styles.navbar,
        ]}>
        {this.renderContent()}
      </View>
    )
  }
}

export default MainNavBarScreen
